import { render, staticRenderFns } from "./cellphone-validation.vue?vue&type=template&id=22aebf68"
import script from "./cellphone-validation.vue?vue&type=script&lang=js"
export * from "./cellphone-validation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports